import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

// Cortex ThemeToggle — an icon control that flips between dark and light via
// useTheme().toggleTheme. Sun/Moon icons cross-fade with a smooth transition
// (DESIGN_LANGUAGE_SPEC §26, §27: "Theme switch: smooth transition").

export interface ThemeToggleProps {
  className?: string | undefined;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`}
      aria-pressed={isDark}
      className={`inline-flex h-11 w-11 items-center justify-center rounded-xl border transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/40 ${
        isDark
          ? 'border-white/[0.06] bg-white/[0.04] text-white/70 hover:bg-white/[0.08] hover:text-white'
          : 'border-slate-200 bg-slate-100 text-slate-600 hover:bg-slate-200 hover:text-slate-900'
      } ${className ?? ''}`}
    >
      <span className="relative block h-5 w-5">
        <Sun
          className={`absolute inset-0 h-5 w-5 transition-all duration-300 ${
            isDark ? 'rotate-0 scale-100 opacity-100' : 'rotate-90 scale-0 opacity-0'
          }`}
          aria-hidden="true"
        />
        <Moon
          className={`absolute inset-0 h-5 w-5 transition-all duration-300 ${
            isDark ? '-rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'
          }`}
          aria-hidden="true"
        />
      </span>
    </button>
  );
}
